import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Package } from '../../models/package.model'
import { Subscription } from 'rxjs'
import { TranslateService } from '@ngx-translate/core'
import { serviceDetails } from 'src/app/modules/services/models/service-template.model'

@Component({
	selector: 'app-add-view-package-service',
	templateUrl: './add-view-package-service.component.html',
	styleUrls: ['./add-view-package-service.component.scss'],
})
export class AddViewPackageServiceComponent implements OnInit {
	@Input() packageData!: Package
	@Input() totalCount!: number
	@Output() emitData = new EventEmitter()
	@Output() addServiceMode = new EventEmitter()
	@Input() isEditMode!: boolean
	@Input() viewMode!: boolean
	subscription = new Subscription()

	// packageForm: FormGroup = new FormGroup({})
	// oldValues = null
	// isChanged = false
	today = new Date()
	// @Input() packageFilter!: packageFilter
	// @Input() open!: boolean

	constructor(public translate: TranslateService) {}

	ngOnInit(): void {}

	onSaved(isSave: boolean) {
		this.emitData.emit({
			value: this.packageData.packageServices,
			isValid: this.packageData.packageServices.length,
			isSave: isSave,
		})
	}
	deleteService(service: serviceDetails) {
		let serviceIndex = this.packageData?.packageServices.findIndex(
			(s) => s.id === service.id
		)
		this.packageData?.packageServices.splice(serviceIndex, 1)
		// this.emitData.emit(this.packageData.packageServices)
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
